import React from 'react';
import styled from '@emotion/styled';

import { colors } from '../../theme/colors';
import { headers } from '../../styles/type';
import { fontWeights } from '../../theme/type';

const Label = styled.div`
  ${headers.h6}
  font-weight: ${fontWeights.medium};
  color: ${colors.blue['500']};

  ${({ theme }) => theme.pageOverrides?.includes('Dark Mode') && `
    color: ${colors.blue['100']};
  `}
`;

const DropdownLabel = ({ children }) => (
  <Label aria-hidden="true" role="presentation">{children}</Label>
);

export default DropdownLabel;
